import {
  USER_LOADED,
  AUTH_ERROR,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT,
  CLEAR_ERRORS,
  AUTH_OK
} from "../types";

export default (state, action) => {
  
  switch (action.type) {
    case USER_LOADED:
      localStorage.setItem("user", JSON.stringify(action.payload));
      localStorage.setItem("permission", JSON.stringify(action.permission));
      localStorage.setItem("lastTimeStamp", new Date().getTime());
      
      return {
        ...state,
        isAuthenticated: true,
        loading: false
      };
    case LOGIN_SUCCESS:
      localStorage.setItem("token", action.payload.token);
      return {
        ...state,
        ...action.payload,
        isAuthenticated: true,
        loading: false
      };
    case AUTH_ERROR:
    case LOGIN_FAIL:
    case LOGOUT:
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      localStorage.removeItem("permission");
      localStorage.removeItem("lastTimeStamp");

      return {
        ...state,
        token: null,
        isAuthenticated: false,
        loading: false,
        error: action.payload
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null
      };
    case AUTH_OK:
        
      return {
        ...state,
        isAuthenticated: true,
        loading: true
      };
    default:
      return state;
  }
};
